// @flow

// InboxButtonController manages reference for the inbox button
// and provide to new inbox panel via context.

import * as React from 'react';
import InboxButtonContext from 'app/common/react/components/growth/news/ConversationsPanel/InboxButtonContext';

type Props = {|
  children: ?React.Node,
|};

export default function InboxButtonController({ children }: Props) {
  const [inboxButton, setInboxButton] = React.useState(null);
  const [profileInboxButton, setProfileInboxButton] = React.useState(null);

  return (
    <InboxButtonContext.Provider
      value={{ inboxButton, setInboxButton, profileInboxButton, setProfileInboxButton }}
    >
      {children}
    </InboxButtonContext.Provider>
  );
}

export function withInboxContext<Props: {}>(Component: React.ComponentType<Props>) {
  return (props: any) => (
    <InboxButtonContext.Consumer>
      {({ inboxButton, setInboxButton, profileInboxButton, setProfileInboxButton }) => (
        <Component
          {...props}
          inboxButton={inboxButton}
          setInboxButton={setInboxButton}
          profileInboxButton={profileInboxButton}
          setProfileInboxButton={setProfileInboxButton}
        />
      )}
    </InboxButtonContext.Consumer>
  );
}
